<template>
  <div>
    <slot name="file-actions-content"/>
    <anchor-tooltip-btn
      small
      left
      is-icon
      v-for="(action, idx) in actions"
      :key="action.icon"
      :disabled="action.disabled"
      :icon="action.icon"
      :tooltip="action.tooltip"
      :color="action.color || 'secondary'"
      :id="`action-btn-${idx}`"
      @click="$emit(action.clickBtnEventName, file)"
    />
  </div>
</template>

<script>
import AnchorTooltipBtn from '../buttons/TooltipBtn';

export default {
  name: 'AnchorFileActions',
  components: {
    AnchorTooltipBtn,
  },
  props: {
    actions: {
      type: Array,
      required: true,
    },
    file: {
      type: Object,
      required: true,
    },
  },
};
</script>
